import { Body14Medium } from "@/components/typography/Body14Medium";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Strong } from "@/components/typography/Body14Strong";
import { Body16Regular } from "@/components/typography/Body16Regular";
import { H4 } from "@/components/typography/H4";
import { H5 } from "@/components/typography/H5";
import { Modal } from "flowbite-react";

type Props = {
  show: boolean;
  onClose: () => void;
  onActivate: () => void;
  isActive: boolean;
};

const CanPayLaterModal = ({ show, onClose, onActivate, isActive }: Props) => {
  return (
    <Modal show={show} onClose={onClose} size="2xl">
      <Modal.Header className="border-b border-[#1c375a]/20">
        <H4>후불 결제</H4>
      </Modal.Header>

      <Modal.Body className="p-6">
        <div className="w-full flex-col justify-start items-center gap-5 inline-flex overflow-hidden truncate">
          <div className="flex-col justify-start items-center gap-1 flex">
            <div className="mb-1">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99935 1.66699C8.35117 1.66699 6.74001 2.15573 5.3696 3.07141C3.99919 3.98709 2.93109 5.28858 2.30036 6.8113C1.66963 8.33401 1.5046 10.0096 1.82614 11.6261C2.14769 13.2426 2.94136 14.7274 4.1068 15.8929C5.27223 17.0583 6.75709 17.852 8.3736 18.1735C9.99011 18.4951 11.6657 18.33 13.1884 17.6993C14.7111 17.0686 16.0126 16.0005 16.9283 14.6301C17.8439 13.2597 18.3327 11.6485 18.3327 10.0003C18.3303 7.79093 17.4515 5.67273 15.8892 4.11045C14.327 2.54817 12.2087 1.66942 9.99935 1.66699ZM9.99935 14.167C9.83453 14.167 9.67342 14.1181 9.53638 14.0265C9.39934 13.935 9.29253 13.8048 9.22945 13.6526C9.16638 13.5003 9.14988 13.3327 9.18203 13.1711C9.21419 13.0094 9.29355 12.8609 9.4101 12.7444C9.52664 12.6279 9.67513 12.5485 9.83678 12.5163C9.99843 12.4842 10.166 12.5007 10.3183 12.5638C10.4705 12.6268 10.6007 12.7336 10.6922 12.8707C10.7838 13.0077 10.8327 13.1688 10.8327 13.3337C10.8327 13.5547 10.7449 13.7666 10.5886 13.9229C10.4323 14.0792 10.2204 14.167 9.99935 14.167ZM10.8327 10.8337C10.8327 11.0547 10.7449 11.2666 10.5886 11.4229C10.4323 11.5792 10.2204 11.667 9.99935 11.667C9.77834 11.667 9.56638 11.5792 9.4101 11.4229C9.25382 11.2666 9.16602 11.0547 9.16602 10.8337V6.66699C9.16602 6.44598 9.25382 6.23402 9.4101 6.07774C9.56638 5.92146 9.77834 5.83366 9.99935 5.83366C10.2204 5.83366 10.4323 5.92146 10.5886 6.07774C10.7449 6.23402 10.8327 6.44598 10.8327 6.66699V10.8337Z" fill="#E80A4D" />
              </svg>
            </div>
            <H5 className="text-[#e80a4d]">후불결제는 익월 입금을 허용합니다. </H5>
            <Body14Regular className="text-[#e80a4d]">익월 말일이 지난 일자에도 금액 납입이 미뤄질 경우, 비활성화로 변경해야합니다.</Body14Regular>
          </div>
          <div className="flex-col justify-start items-start gap-2 flex">
            <div className="justify-center items-start gap-4 inline-flex">
              <Body14Strong className="w-28 ">세금계산서 발행시기</Body14Strong>
              <Body14Regular >익월 5영업일 내</Body14Regular>
            </div>
            <div className="justify-center items-start gap-4 inline-flex">
              <Body14Strong className="w-28">세금계산서 발행기준</Body14Strong>
              <Body14Regular >당월 말일자 출고건/대금 합산 발행</Body14Regular>
            </div>
            <div className="justify-center items-start gap-4 inline-flex">
              <Body14Strong className="w-28 ">입금 기한</Body14Strong>
              <Body14Regular >익월 말일</Body14Regular>
            </div>
            <div className="justify-center items-start gap-4 inline-flex">
              <Body14Strong className="w-28 ">세금계산서 발송</Body14Strong>
              <Body14Regular >가입 시 입력한 세금계산서 발송 이메일</Body14Regular>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-t border-[#1c375a]/20">
        <button
          onClick={onActivate}
          className="px-5 py-2.5 bg-black rounded-lg justify-center items-center gap-2 flex"
        >
          <Body14Medium className="text-white">
            {isActive ? "비활성화하기" : "활성화하기"}
          </Body14Medium>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CanPayLaterModal;
